/**
 * Onde um popover portalado deve ser montado.
 *
 * Os modais são `<dialog>` com `showModal()`: tudo fora deles vira inerte e
 * fica embaixo da camada superior. Um menu portalado para o `body` a partir
 * de dentro de um modal nem receberia clique. Por isso o alvo é o `<dialog>`
 * aberto mais próximo, quando há um — e o `body` quando não há.
 */
export function alvoDoPortal(origem: Element | null): HTMLElement {
  const dialogo = origem?.closest('dialog');
  return dialogo instanceof HTMLDialogElement && dialogo.open ? dialogo : document.body;
}
